/* eslint max-classes-per-file: 0 */

import {
  UserHistory as Data,
  UserHistoryCollection as Collection,
} from '@/typings/api/User'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class UsersHistoryApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'users/history';
}
